<template>
  <fieldset :id="field.name" class="fieldset-reset" :class="{ 'required-empty': requiredEmpty }" :style="field.style || undefined">
    <!--
      legend に質問テキストを入れることで SR が「質問: 選択肢...」と読む。
      視覚は通常のラベル風にしたいので CSS でブロックレベルに配置 (float なし)。
    -->
    <legend class="block text-sm font-semibold text-q4cl-primary mb-1.5 leading-snug">
      {{ displayName }}
      <span v-if="field.required" class="tag-required" :aria-label="$t('必須項目')">{{ $t('※必須') }}</span>
      <span v-else-if="showOptional" class="tag-optional" aria-hidden="true">{{ $t('※任意') }}</span>
    </legend>

    <div
      v-if="field.description"
      class="text-sm text-q4cl-muted mb-2 leading-relaxed"
      v-html="sanitizedDescription"
    ></div>

    <!--
      旧旧版踏襲 (Q4CL-client_old_version.xml:268-287, setFields:3593-3596):
      親 div は単純な縦並び (space-y-1)、 inline=true のときは各 label に
      display: inline-block + 横 margin だけで横並びにする (flex 使わない)。
      これによりラベル文字が縦書きに潰れず、 自然な文字幅で並ぶ。
    -->
    <div :class="inline ? '-mr-2' : 'space-y-1.5'" role="radiogroup">
      <label
        v-for="(sel, key) in field.sels"
        :key="key"
        :class="['choice-label', sel.checked ? 'checked' : '', inline ? 'choice-inline' : '']"
      >
        <input
          type="radio"
          :name="field.name"
          :value="sel.value"
          :checked="sel.checked"
          :required="field.required"
          @change="select(key)"
        />
        <span class="text-sm text-q4cl-ink">{{ $t(sel.value) }}</span>
      </label>
    </div>

  </fieldset>
</template>

<script>
export default {
  name: 'RadioField',
  props: {
    field: { type: Object, required: true },
    showOptional: { type: Boolean, default: false }
  },
  setup(props) {
    const i18n = window.i18nStore;
    const inline = Vue.computed(() => !!props.field.inline);

    const displayName = Vue.computed(() => i18n ? i18n.i18n(props.field.dispname) : props.field.dispname);

    // 旧旧版踏襲: 配列なら \n で join、 marked.parse で block-level Markdown サポート
    const sanitizedDescription = Vue.computed(() => {
      try {
        const raw = props.field.description;
        if (!raw) return '';
        const joined = Array.isArray(raw) ? raw.join('\n') : raw;
        const translated = i18n ? i18n.i18n(joined) : joined;
        return DOMPurify.sanitize(marked.parse(translated));
      } catch (e) { return props.field.description; }
    });

    function select(key) {
      for (const k in props.field.sels) props.field.sels[k].checked = (k === key);
      props.field.value = props.field.sels[key].value;
    }

    const requiredEmpty = Vue.computed(() => {
      const fs = window.fieldSerializer;
      return fs ? fs.isRequiredAndEmpty(props.field) : false;
    });

    return { inline, displayName, sanitizedDescription, select, requiredEmpty };
  }
};
</script>
